import axios from 'axios'
import config from '../../config'

const baseUrl = `${config.backend}locale/`

export const getLocales = async () => {
    const response = await axios.get(baseUrl)
    return response.data
}
